class ProductList {
  public element: HTMLElement;
  public sortSelect: HTMLSelectElement | null;
  public productList: NodeListOf<HTMLElement> | null;
  public filterTrigger: NodeListOf<HTMLElement> | null;
  public filterToggle: HTMLElement | null;
  public filterContainer: HTMLElement | null;
  public filterCloseBtn: HTMLElement | null;
  public filterCount: HTMLElement | null;
  public layoutToggle: NodeListOf<HTMLElement> | null;
  public tabSwitches: NodeListOf<HTMLElement> | null;
  public selectedFilter = {};
  public sortBy: string = '';
  public order: string = '';
  public activeClass: string = 'm-product-filters__item--active';
  public deliveryCountryInput: HTMLInputElement | null;
  public currentTaxRateInput: HTMLInputElement | null;
  public deliveryCountryCurrency: string;
  public currentTaxRate: string;
  public currentCurrency: string;

  constructor(el: HTMLElement) {
    this.element = el;
  }

  handleSort() {
    const productList: NodeListOf<HTMLElement> | null = this.element.querySelectorAll('.o-tabs__content.is--active .m-product-list-teaser');

    const list = Array.from(productList || []);

    list.sort((a: HTMLElement, b: HTMLElement): number => {
      // @ts-ignore
      return a.dataset[this.sortBy]?.replace(',', '.') - b.dataset[this.sortBy]?.replace(',', '.');
    });

    if (this.order === 'desc') {
      list.reverse();
    }

    list.forEach((teaser, i) => {
      const teaserParent = teaser.closest('.o-tabs__content-teaser') as HTMLElement | null;
      if (teaserParent) {
        teaserParent.style.order = `${i}`;
      }
    });
  }

  async changeToVariant(product: HTMLElement, variant: any) {
    let imageWrapper = product?.querySelector('.m-product-list-teaser__image-no-hover') as HTMLElement | null;
    let imageHoverWrapper = product?.querySelector('.m-product-list-teaser__image-hover') as HTMLElement | null;
    let imageWrapperWide = product?.querySelector('.m-product-list-teaser__image-no-hover--wide') as HTMLElement | null;
    let imageHoverWrapperWide = product?.querySelector('.m-product-list-teaser__image-hover--wide') as HTMLElement | null;

    if (imageWrapper) {
      imageWrapper.style.opacity = '0';
      setTimeout(() => {
        if (imageWrapper) {
          imageWrapper.style.backgroundImage = `url(${variant.image})`;
          imageWrapper.dataset.currentSrc = variant.image;
          imageWrapper.dataset.bg = variant.image;
          imageWrapper.style.opacity = '1';
        }
      }, 250);
    }
    if (imageHoverWrapper) {
      imageHoverWrapper.style.backgroundImage = `url(${variant.image_hover})`;
      imageHoverWrapper.dataset.currentSrc = variant.image_hover;
      imageHoverWrapper.dataset.bg = variant.image_hover;
    }
    if (imageWrapperWide) {
      imageWrapperWide.style.opacity = '0';
      setTimeout(() => {
        if (imageWrapperWide) {
          imageWrapperWide.style.backgroundImage = `url(${variant.image_two_columns})`;
          imageWrapperWide.dataset.currentSrc = variant.image_two_columns;
          imageWrapperWide.dataset.bg = variant.image_two_columns;
          imageWrapperWide.style.opacity = '1';
        }
      }, 250);
    }
    if (imageHoverWrapperWide) {
      imageHoverWrapperWide.style.backgroundImage = `url(${variant.image_two_columns_hover})`;
      imageHoverWrapperWide.dataset.currentSrc = variant.image_two_columns_hover;
      imageHoverWrapperWide.dataset.bg = variant.image_two_columns_hover;
    }

    const imageLink = product?.querySelector('.js-m-product-list-teaser-link') as HTMLLinkElement | null;
    const titleLink = product?.querySelector('.js-m-product-list-teaser-link-title') as HTMLLinkElement | null;
    const wishlistLink = product?.querySelector('.js-product-teaser-wishlist-button') as HTMLLinkElement | null;
    const colorsBubbles = product?.querySelectorAll('.m-product-list-teaser__colors-item') as NodeListOf<HTMLLinkElement> | null;
    const priceWrapper = product?.querySelector('.m-product-list-teaser__price span:first-child') as HTMLElement | null;

    if (colorsBubbles) {
      const bubblesForRequests: any[] = [];
      const requests: any[] = [];

      colorsBubbles.forEach(async (bubble) => {
        bubble.classList.remove('is--active');

        if (bubble.dataset.color === variant.filter_attributes.variant_color[0]) {
          bubble.classList.add('is--active');

          if (imageLink) {
            imageLink.href = bubble.href;
          }

          if (titleLink) {
            titleLink.href = bubble.href;
          }

          if (wishlistLink) {
            bubblesForRequests.push(bubble);
            requests.push(fetch(`/api/v1/wishlist/in-list/id/${variant.id}`));
          }

          if (priceWrapper) {
            const price = variant[`price-${this.deliveryCountryCurrency.toLowerCase()}`][`${this.currentTaxRate}`].price;
            const currency = variant[`price-${this.deliveryCountryCurrency.toLowerCase()}`][`${this.currentTaxRate}`].currency;
            priceWrapper.textContent = `${bubble.dataset.showPriceFromText} ${currency} ${price}`;
            priceWrapper.dataset.currentPrice = price;
            priceWrapper.dataset.currency = currency;

            if (variant.request_only) {
              priceWrapper.classList.add('hide-price');
            } else {
              priceWrapper.classList.remove('hide-price');
            }

            product.dataset.price = price.replace('.', '');
          }
        }
      });

      const res = await Promise.all(requests);

      res.forEach(async (res, i) => {
        const jsonRes = await res.json();

        const count: any = [];
        const bubble = bubblesForRequests[i];

        if (wishlistLink) {
          if (jsonRes.lists.length) {
            jsonRes.lists.forEach((list: any) => {
              count.push({'listId': list})
            })

            wishlistLink.classList.add('is-active');
            wishlistLink.dataset.action = 'remove';
            wishlistLink.href = wishlistLink.dataset.removeUrl || wishlistLink.href;
            wishlistLink.dataset.count = JSON.stringify(count);
            bubble.dataset.isOnWishlist = '1';
          } else {
            wishlistLink.classList.remove('is-active');
            wishlistLink.dataset.action = 'add';
            wishlistLink.href = wishlistLink.dataset.addUrl || wishlistLink.href;
            wishlistLink.dataset.count = JSON.stringify([]);
            bubble.dataset.isOnWishlist = '0';
          }

          const url = new URL(wishlistLink.href);

          url.searchParams.set('elementId', String(bubble.dataset.variantId));
          url.searchParams.set('fields[plaintext_title_1]', '1');

          if (count.length) {
            url.searchParams.set('listId', String(count[0]?.listId));
          } else {
            url.searchParams.delete('listId');
          }

          wishlistLink.href = String(url);
        }
      })
    }
  }

  filterProducts() {
    const productList: NodeListOf<HTMLElement> | null = this.element.querySelectorAll('.o-tabs__content.is--active .m-product-list-teaser');

    productList.forEach((product) => {
      const variants = JSON.parse(product?.querySelector('.m-product-list-teaser-variants')?.innerHTML || '[]');

      let keepCheckingVariant = true;
      let keepCheckingFilter = true;
      let foundVariant = null;

      variants.forEach((variant: any) => {
        keepCheckingFilter = true;

        if (keepCheckingVariant) {
          Object.entries(this.selectedFilter).forEach(([filter, selected]: [string, any]) => {
            if (keepCheckingFilter) {
              if (filter === 'variant_color' && variant.filter_attributes[filter].includes('blank')) {
                // selected filter is color and variant is blank check next selected filter
              } else if (variant.filter_attributes[filter] && selected.some((item: any) => variant.filter_attributes[filter].includes(item))) {
                // selected filter is in variant -> check next selected filter
              } else {
                // selected filter is not in variant -> can go to next variant
                keepCheckingFilter = false;
              }
            } else {
              return;
            }
          });

          if (keepCheckingFilter) {
            // think this means we found a variant
            keepCheckingVariant = false;
            foundVariant = variant;
          }
        }
      });

      if (foundVariant) {
        this.changeToVariant(product, foundVariant);
        const priceWrapper = product?.querySelector('.m-product-list-teaser__price span:first-child') as HTMLElement | null;
        if (priceWrapper) {
          const variantPriceObj = foundVariant[`price-${this.deliveryCountryCurrency.toLowerCase()}`][`${this.currentTaxRate}`];
          if (variantPriceObj) {
            // @ts-ignore
            priceWrapper.dataset.price = variantPriceObj.price;
            // @ts-ignore
            priceWrapper.dataset.currentPrice = variantPriceObj.price;
          }
        }
        product.closest('.o-tabs__content-teaser')?.classList.remove('hide');
      } else {
        product.closest('.o-tabs__content-teaser')?.classList.add('hide');
      }
    });
  }

  resetFilter() {
    this.selectedFilter = {};
    this.filterTrigger?.forEach((trigger) => trigger.classList.remove(this.activeClass));
    this.productList?.forEach(async (product) => {
      product.closest('.o-tabs__content-teaser')?.classList.remove('hide');
      const variants = JSON.parse(product?.querySelector('.m-product-list-teaser-variants')?.innerHTML || '[]');

      let imageWrapper = product?.querySelector('.m-product-list-teaser__image-no-hover') as HTMLElement | null;
      let imageHoverWrapper = product?.querySelector('.m-product-list-teaser__image-hover') as HTMLElement | null;
      let imageWrapperWide = product?.querySelector('.m-product-list-teaser__image-no-hover--wide') as HTMLElement | null;
      let imageHoverWrapperWide = product?.querySelector('.m-product-list-teaser__image-hover--wide') as HTMLElement | null;

      if (imageWrapper) {
        imageWrapper.style.opacity = '0';
        setTimeout(() => {
          if (imageWrapper) {
            imageWrapper.dataset.bg = imageWrapper.dataset.originalSrc;
            imageWrapper.style.backgroundImage = `url(${imageWrapper.dataset.originalSrc})`;
            imageWrapper.style.opacity = '1';
          }
        }, 250);
      }
      if (imageHoverWrapper) {
        imageHoverWrapper.dataset.bg = imageHoverWrapper.dataset.originalSrc;
        imageHoverWrapper.style.backgroundImage = `url(${imageHoverWrapper.dataset.originalSrc})`;
      }
      if (imageWrapperWide) {
        imageWrapperWide.style.opacity = '0';
        setTimeout(() => {
          if (imageWrapperWide) {
            imageWrapperWide.dataset.bg = imageWrapperWide.dataset.originalSrc;
            imageWrapperWide.style.backgroundImage = `url(${imageWrapperWide.dataset.originalSrc})`;
            imageWrapperWide.style.opacity = '1';
          }
        }, 250);
      }
      if (imageHoverWrapperWide) {
        imageHoverWrapperWide.dataset.bg = imageHoverWrapperWide.dataset.originalSrc;
        imageHoverWrapperWide.style.backgroundImage = `url(${imageHoverWrapperWide.dataset.originalSrc})`;
      }

      const priceWrapper = product?.querySelector('.m-product-list-teaser__price span:first-child') as HTMLElement | null;

      if (priceWrapper) {
        const price = priceWrapper.dataset[`price${this.deliveryCountryCurrency.toLowerCase()}-${this.currentTaxRate.split('.')[this.currentTaxRate.split('.').length - 1]}`];
        priceWrapper.textContent = `${priceWrapper.dataset.priceText} ${variants[0][`price-${this.deliveryCountryCurrency.toLowerCase()}`][`${this.currentTaxRate}`].currency} ${price}`;
        priceWrapper.dataset.price = price;
        product.dataset.price = price?.replace('.', '');

        if (priceWrapper.dataset.price) {
          priceWrapper.classList.remove('hide-price');
        } else {
          priceWrapper.classList.add('hide-price');
        }
      }

      const colorsBubbles = product?.querySelectorAll('.m-product-list-teaser__colors-item') as NodeListOf<HTMLElement> | null;

      if (colorsBubbles) {
        colorsBubbles.forEach((bubble, i) => {
          bubble.classList.remove('is--active');

          if (i === 0) {
            bubble.classList.add('is--active');
          }
        });
      }

      const imageLink = product?.querySelector('.js-m-product-list-teaser-link') as HTMLLinkElement | null;
      const titleLink = product?.querySelector('.js-m-product-list-teaser-link-title') as HTMLLinkElement | null;

      if (imageLink) {
        imageLink.href = imageLink.dataset.originalHref || imageLink.href;
      }
      if (titleLink) {
        titleLink.href = titleLink.dataset.originalHref || titleLink.href;
      }

      const wishlistLink = product?.querySelector('.js-product-teaser-wishlist-button') as HTMLLinkElement | null;

      if (wishlistLink) {
        const standardVariantId = variants[0]?.id;

        const count: any = [];

        try {
          const res = await fetch(`/api/v1/wishlist/in-list/id/${standardVariantId}`);
          const jsonRes = await res.json()

          if (jsonRes.lists.length) {
            jsonRes.lists.forEach((list: any) => {
              count.push({'listId': list})
            })

            wishlistLink.classList.add('is-active');
            wishlistLink.dataset.action = 'remove';
            wishlistLink.href = wishlistLink.dataset.removeUrl || wishlistLink.href;
            wishlistLink.dataset.count = JSON.stringify(count);
            if (colorsBubbles) {
              colorsBubbles[0].dataset.isOnWishlist = '1';
            }
          } else {
            wishlistLink.classList.remove('is-active');
            wishlistLink.dataset.action = 'add';
            wishlistLink.href = wishlistLink.dataset.addUrl || wishlistLink.href;
            wishlistLink.dataset.count = JSON.stringify([]);
            if (colorsBubbles) {
              colorsBubbles[0].dataset.isOnWishlist = '0';
            }
          }
        } catch (e) {
          wishlistLink.classList.remove('is-active');
        }

        const url = new URL(wishlistLink.href);

        url.searchParams.set('elementId', String(standardVariantId));
        url.searchParams.set('fields[plaintext_title_1]', '1');

        if (count.length) {
          url.searchParams.set('listId', String(count[0]?.listId));
        } else {
          url.searchParams.delete('listId');
        }

        wishlistLink.href = String(url);
      }
    });

    this.handleSort();
  }

  handleFilter(button: HTMLElement, filter: string, option: string) {
    if (filter === 'reset') {
      this.resetFilter();
    } else {
      if (button.classList.contains(this.activeClass)) {
        button.classList.remove(this.activeClass);
        // @ts-ignore
        delete this.selectedFilter[filter];
      } else {
        button.parentElement?.querySelectorAll('.m-product-filters__item')?.forEach((trigger) => trigger.classList.remove(this.activeClass));

        if (!button.classList.contains(this.activeClass)) {
          button.classList.add(this.activeClass);
          // @ts-ignore
          this.selectedFilter[filter] = [option];
        }
      }

      this.filterProducts();
    }
  }

  toggleFilters() {
    if (this.filterContainer) {
      this.filterContainer.classList.toggle('is--active');
      if (this.filterContainer.style.maxHeight) {
        this.filterContainer.style.maxHeight = '0';
        setTimeout(() => {
          // @ts-ignore
          this.filterContainer.style.maxHeight = null;
        }, 300);
      } else {
        this.filterContainer.style.maxHeight = this.filterContainer.scrollHeight + 'px';
      }
    }
  }

  bindings() {
    this.handleSort = this.handleSort.bind(this);

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => {
        let selectedOption = this.sortSelect?.value;
        // @ts-ignore
        let [sortBy, order] = selectedOption?.split('_');

        this.sortBy = sortBy;
        this.order = order;

        this.handleSort();
      })
    }

    if (this.filterTrigger) {
      this.filterTrigger.forEach((trigger) => {
        trigger.addEventListener('click', (e: Event) => {
          const button = e.target as HTMLElement;
          const filter = button.dataset.filter || '';
          const option = button.dataset.option || '';

          this.handleFilter(button, filter, option);
          this.handleFilterCount();
        });
      });
    }

    if (this.tabSwitches) {
      this.tabSwitches.forEach((tabSwitch) => {
        tabSwitch.addEventListener('click', () => {
          this.resetFilter();
        });
      });
    }

    if (this.filterToggle && this.filterContainer) {
      this.filterToggle.addEventListener('click', () => {
        this.toggleFilters();
      });
    }

    if (this.filterCloseBtn) {
      this.filterCloseBtn.addEventListener('click', () => {
        this.toggleFilters();
      });
    }

    if(this.layoutToggle) {
      this.layoutToggle.forEach((toggle) => {
        toggle.addEventListener('click', (e: Event) => {
          const target = e.target as HTMLElement;
          this.layoutToggle?.forEach((element) => {
            element.classList.remove('is--active');
          });
          target.classList.add('is--active');
          const tabContent = this.element.querySelectorAll('.o-tabs__content');
          tabContent.forEach((tab) => {
            (tab as HTMLElement).dataset.mobileColumns = target.dataset.columns;
          });
        });
      })
    }
  }

  handleFilterCount() {
    if(Object.keys(this.selectedFilter).length == 0) {
      // @ts-ignore
      this.filterCount?.innerText = '';
    } else {
      // @ts-ignore
      this.filterCount?.innerText = `(${Object.keys(this.selectedFilter).length})`;
    }
  }

  cache() {
    this.sortSelect = this.element.querySelector('.js-o-product-list__sort');
    this.productList = this.element.querySelectorAll('.o-tabs__content .m-product-list-teaser');
    this.filterTrigger = this.element.querySelectorAll('.m-product-filters__item');
    this.filterToggle = this.element.querySelector('.js-o-product-list__filters-toggle');
    this.filterContainer = this.element.querySelector('.js-o-product-list__filters');
    this.filterCloseBtn = this.element.querySelector('.js-o-product-list__filters__close');
    this.filterCount = this.element.querySelector('.js-o-product-list__filters-count');
    this.layoutToggle = this.element.querySelectorAll('.js-o-product-list__layout');
    this.tabSwitches = this.element.querySelectorAll('.js-tab-switch');
    this.deliveryCountryInput = document.querySelector('.js-ld-label input[checked]');
    this.currentTaxRateInput = document.querySelector('.js-ls-delivery-country-form input[name="currentTaxRate"]');
    this.deliveryCountryCurrency = this.deliveryCountryInput?.dataset.currency || 'EUR';
    this.currentTaxRate = this.currentTaxRateInput?.value || '0';
    this.currentCurrency = '€';
  }

  init() {
    this.cache();
    this.bindings();

    // Init product list
    switch (this.deliveryCountryCurrency.toLowerCase()){
      case 'eur':
        this.currentCurrency = '€';
        break;

      case 'usd':
        this.currentCurrency = '$';
        break;

      case 'chf':
        this.currentCurrency = 'CHF';
        break;
    }

    const productList: NodeListOf<HTMLElement> | null = this.element.querySelectorAll('.o-tabs__content.is--active .m-product-list-teaser');

    productList.forEach((product) => {
      const priceWrapper = product?.querySelector('.m-product-list-teaser__price span:first-child') as HTMLElement | null;
      if (priceWrapper) {
        priceWrapper.dataset.currency = this.currentCurrency;
        priceWrapper.dataset.price = priceWrapper.dataset['price' + this.deliveryCountryCurrency.toLowerCase() + '-' + this.currentTaxRate.replace('0.', '')];
        priceWrapper.dataset.currentPrice = priceWrapper.dataset['price' + this.deliveryCountryCurrency.toLowerCase() + '-' + this.currentTaxRate.replace('0.', '')];
      }
    });
  }
}

export default ProductList;
